var _path, _g, _path2, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSocEnergyOnMonth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.19995 14.2C4.19995 8.67717 8.6771 4.20001 14.1999 4.20001H27.7999C33.3228 4.20001 37.7999 8.67716 37.7999 14.2V27.8C37.7999 33.3229 33.3228 37.8 27.8 37.8H14.2C8.67711 37.8 4.19995 33.3229 4.19995 27.8V14.2Z",
    fill: "#03A3E8",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12724_570)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2859 12.3079C22.3013 12.311 22.3166 12.3141 22.3318 12.3172C26.2026 13.0994 29.1156 16.5252 29.1156 20.6326C29.1156 25.316 25.327 29.1156 20.65 29.1156C15.9729 29.1156 12.1843 25.316 12.1843 20.6326C12.1843 18.2603 13.1571 16.114 14.7234 14.5752C15.0265 14.2773 15.5138 14.2816 15.8117 14.5848C16.1096 14.888 16.1053 15.3752 15.8021 15.6731C14.5187 16.9341 13.7235 18.6894 13.7235 20.6326C13.7235 24.4692 16.8262 27.5764 20.65 27.5764C24.4737 27.5764 27.5764 24.4692 27.5764 20.6326C27.5764 17.2697 25.1915 14.4654 22.0269 13.8259C21.8622 13.7926 21.7357 13.7671 21.6266 13.749C21.5444 13.7354 21.4858 13.7283 21.4432 13.7254C21.4218 13.865 21.4196 14.0711 21.4196 14.4619V15.2332C21.4196 15.6583 21.075 16.0028 20.65 16.0028C20.2249 16.0028 19.8804 15.6583 19.8804 15.2332V14.4619C19.8804 14.4461 19.8803 14.4302 19.8803 14.4144C19.8802 14.0819 19.8801 13.746 19.9257 13.4671C19.9799 13.1351 20.1121 12.7852 20.444 12.513C20.7567 12.2565 21.0987 12.1786 21.4343 12.1847C21.702 12.1896 22.0048 12.2509 22.2859 12.3079Z",
    fill: "#87FF0B",
    stroke: "#87FF0B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.127 16.2545C17.3417 16.0798 17.6488 16.0775 17.866 16.249L22.134 19.6192C23.0389 20.3337 23.0436 21.6982 22.1434 22.4189C21.2486 23.1353 19.9126 22.8491 19.3981 21.8217L16.9719 16.977C16.8479 16.7295 16.9124 16.4292 17.127 16.2545Z",
    fill: "#87FF0B"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 37.625C22.75 37.625 22.1968 37.625 21 37.625C13.1629 37.625 9.24435 37.625 6.80967 35.1903C4.375 32.7557 4.375 28.8371 4.375 21C4.375 13.1629 4.375 9.24437 6.80967 6.8097C9.24435 4.37502 13.1629 4.37502 21 4.37502C28.8371 4.37502 32.7556 4.37502 35.1903 6.8097C37.625 9.24437 37.625 13.1629 37.625 21C37.625 22.1969 37.625 22.75 37.625 22.75",
    stroke: "#1EF5DF",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_12724_570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.5333 27.0667V28.4667M30.7999 27.0667V28.4667",
    stroke: "#1EF5DF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0388 30.4889H37.2944",
    stroke: "#1EF5DF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4944 32.7991C27.4944 30.4268 27.4944 29.2407 28.1761 28.5037C28.8578 27.7667 29.955 27.7667 32.1494 27.7667H33.1838C35.3782 27.7667 36.4754 27.7667 37.1571 28.5037C37.8388 29.2407 37.8388 30.4268 37.8388 32.7991V33.0787C37.8388 35.451 37.8388 36.6372 37.1571 37.3742C36.4754 38.1111 35.3782 38.1111 33.1838 38.1111H32.1494C29.955 38.1111 28.8578 38.1111 28.1761 37.3742C27.4944 36.6372 27.4944 35.451 27.4944 33.0787V32.7991Z",
    stroke: "#1EF5DF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7666 30.4889H37.5666",
    stroke: "#1EF5DF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 33H36",
    stroke: "#1EF5DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 35H33",
    stroke: "#1EF5DF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12724_570"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.9,
    height: 18.9,
    fill: "white",
    transform: "translate(11.2 11.2)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_12724_570"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.0667,
    height: 14,
    fill: "white",
    transform: "translate(26.1333 25.2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSocEnergyOnMonth);
export default __webpack_public_path__ + "static/media/ic_soc_energy_on_month.7e0967b11687a665b9f1089f4dbb0466.svg";
export { ForwardRef as ReactComponent };